import beautyImg from "../Assets/categories/kiko.webp";
import fragrancesImg from "../Assets/categories/vectoria.avif";
import furnitureImg from "../Assets/categories/furnature.webp";
import homeDecorationImg from "../Assets/categories/decoration.webp";
import kitchenAccessoriesImg from "../Assets/categories/kitchen.webp";
import laptopsImg from "../Assets/categories/laptops.png";
import mobileAccessoriesImg from "../Assets/categories/headphones.webp";
import skinCareImg from "../Assets/categories/skincare.webp";
import smartphonesImg from "../Assets/categories/phone.png";
import sunglassesImg from "../Assets/categories/sunglasses.webp";
import tabletsImg from "../Assets/categories/TAPLET.png";
import topsImg from "../Assets/categories/top.webp";
import womensBagsImg from "../Assets/categories/2_Ladies_Hand_Bag.jpg";
import womensDressesImg from "../Assets/categories/dress.webp";
import womensJewelleryImg from "../Assets/categories/bandora.avif";
import womensShoesImg from "../Assets/categories/heels.avif";
import womensWatchesImg from "../Assets/categories/watch.jpg";

const categoryImages = {
  beauty: beautyImg,
  fragrances: fragrancesImg,
  furniture: furnitureImg,
  "home-decoration": homeDecorationImg,
  "kitchen-accessories": kitchenAccessoriesImg,
  laptops: laptopsImg,
  "mobile-accessories": mobileAccessoriesImg,
  "skin-care": skinCareImg,
  smartphones: smartphonesImg,
  sunglasses: sunglassesImg,
  tablets: tabletsImg,
  tops: topsImg,
  "womens-bags": womensBagsImg,
  "womens-jewellery": womensJewelleryImg,
  "womens-dresses": womensDressesImg,
  "womens-shoes": womensShoesImg,
  "womens-watches": womensWatchesImg,
};

export default categoryImages;
